enum Labels {
  PERSONAL = 'personal',
  HOME = 'home',
  MOBILE = 'mobile',
  BUSINESS = 'business',
  OFFICE = 'office',
  FAX = 'fax',
  WORK = 'work',
}

export default Labels;
